"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_collapse_1 = require("react-collapse");
const polished_1 = require("polished");
const Icon_1 = tslib_1.__importDefault(require("../../Icon"));
const ItemPopup_1 = tslib_1.__importDefault(require("./ItemPopup"));
const LayoutContext_1 = tslib_1.__importDefault(require("../LayoutContext"));
const NavigationLink_1 = tslib_1.__importDefault(require("./NavigationLink"));
const react_1 = tslib_1.__importDefault(require("react"));
const navigationConfig_1 = tslib_1.__importDefault(require("./navigationConfig"));
const styled_components_1 = tslib_1.__importStar(require("../../Themes/styled-components"));
const ICON_SIZE = 24;
const IconWrapper = styled_components_1.default.span `
  width: ${(0, polished_1.rem)(ICON_SIZE)};
  height: ${(0, polished_1.rem)(ICON_SIZE)};
  flex-shrink: 0;
  margin-right: ${(0, polished_1.rem)(12)};
  margin-left: ${(0, polished_1.rem)(4)};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: margin-right 100ms linear;
  ${({ $shrunk }) => $shrunk &&
    (0, styled_components_1.css) `
      margin-right: ${(0, polished_1.rem)(17)};
    `}
`;
const DefaultIconWrapper = styled_components_1.default.span `
  border-radius: ${(0, polished_1.rem)(4)};
  border: ${(0, polished_1.rem)(2)} solid ${({ theme }) => theme.navigation.iconColor};
  color: ${({ theme }) => theme.navigation.iconColor};
  font-size: ${(0, polished_1.rem)(12)};
  font-weight: 800;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Wrapper = styled_components_1.default.li `
  display: block;
  margin-right: 1px;
`;
const DefaultIcon = ({ label }) => {
    return (react_1.default.createElement(DefaultIconWrapper, null, label
        .split(' ')
        .map(word => word[0].toLocaleUpperCase())
        .slice(0, 2)
        .join('')));
};
const Item = ({ label, active, icon, onClick, url, subitems, renderLink, shrunk, theme, getPopupPosition, index, }) => {
    const [itemHovering, setItemHovering] = react_1.default.useState(false);
    const [popupHovering, setPopupHovering] = react_1.default.useState(false);
    const { closeNavigationMobile } = react_1.default.useContext(LayoutContext_1.default);
    const createClickHandler = (item) => {
        if (item.url || item.onClick) {
            return () => {
                item.onClick && item.onClick();
                closeNavigationMobile();
            };
        }
        return undefined;
    };
    const renderSubItem = (item, idx) => {
        return (react_1.default.createElement(NavigationLink_1.default, { key: idx, renderLink: renderLink, forceInteractive: false, onClickItem: createClickHandler(item), label: item.label, active: item.active, url: item.url, onClick: item.onClick, className: navigationConfig_1.default.SUB_ITEM_LINK_CLASS_NAME }, item.label));
    };
    const onClickItem = createClickHandler({ onClick, url });
    const itemIcon = typeof icon === 'string' ? (react_1.default.createElement(Icon_1.default, { name: icon, color: theme.navigation.iconColor, size: ICON_SIZE })) : icon ? (icon) : (react_1.default.createElement(DefaultIcon, { label: label }));
    const subItems = subitems && subitems.length > 0 && subitems.map(renderSubItem);
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement("div", { onMouseEnter: shrunk ? () => setItemHovering(true) : void 0, onMouseLeave: shrunk ? () => setItemHovering(false) : void 0 },
            react_1.default.createElement(NavigationLink_1.default, { renderLink: renderLink, forceInteractive: shrunk, onClickItem: onClickItem, subitems: subitems, icon: icon, label: label, active: active, url: url, onClick: onClick, className: navigationConfig_1.default.ITEM_LINK_CLASS_NAME },
                react_1.default.createElement(IconWrapper, { "$shrunk": shrunk }, itemIcon),
                label)),
        react_1.default.createElement(react_collapse_1.Collapse, { isOpened: !shrunk },
            react_1.default.createElement(react_1.default.Fragment, null, subItems)),
        shrunk && (popupHovering || itemHovering) && (react_1.default.createElement(ItemPopup_1.default, { url: url, label: label, onClick: onClickItem, renderLink: renderLink, active: active, icon: icon, position: getPopupPosition(index), subitems: subitems, onMouseEnter: () => setPopupHovering(true), onMouseLeave: () => setPopupHovering(false) }, subItems))));
};
exports.default = react_1.default.memo((0, styled_components_1.withTheme)(Item));
